import React from "react";
import { useTranslation } from "react-i18next";

/**
 * ActionButtons — กล่องปุ่ม "ยกเลิก" + "ดำเนินการ" ที่อยู่ด้านล่างฟอร์ม
 * ใช้ร่วมกันทุกหน้า AddBuilding
 *
 * Props:
 *  - onCancel        : func    — callback เมื่อกดยกเลิก
 *  - onConfirm       : func    — callback เมื่อกดยืนยัน
 *  - confirmLabel    : string  — ข้อความบนปุ่มยืนยัน (default "บันทึก")
 *  - confirmVariant  : string  — สีปุ่มยืนยัน: "blue" | "yellow" (default "blue")
 *  - confirmDisabled : bool    — ปิดปุ่มยืนยัน (default false)
 *  - errorMessage    : string  — ข้อความ error ที่จะแสดงใต้ปุ่ม (optional)
 *  - fullWidth       : bool    — ถ้า true ปุ่มจะขยายเต็มความกว้าง (default false)
 */
export default function ActionButtons({
  onCancel,
  onConfirm,
  confirmLabel,
  confirmVariant = "blue",
  confirmDisabled = false,
  errorMessage = "",
  fullWidth = false,
}) {
  const { t } = useTranslation();
  const displayConfirmLabel = confirmLabel || t("common.save");

  /** class สีปุ่มยืนยันตาม variant */
  const confirmClass =
    confirmVariant === "yellow"
      ? "bg-yellow-500 text-white font-semibold"
      : "bg-blue-600 text-white";

  /** class ความกว้างปุ่ม */
  const widthClass = fullWidth ? "w-full" : "px-4";

  return (
    <div className="border bg-white rounded-lg mt-2 p-3">
      {/* แถวปุ่ม */}
      <div className={`flex ${fullWidth ? "justify-center" : "justify-end"}`}>
        {/* ปุ่มยกเลิก */}
        <button
          onClick={onCancel}
          className={`mr-2 py-2 ${widthClass} bg-white text-black font-base rounded-lg border border-gray-200 hover:bg-gray-50 transition`}
        >
          {t("common.cancel")}
        </button>

        {/* ปุ่มยืนยัน */}
        <button
          onClick={onConfirm}
          disabled={confirmDisabled}
          className={`py-2 ${widthClass} ${confirmClass} rounded-lg disabled:opacity-60 transition`}
        >
          {displayConfirmLabel}
        </button>
      </div>

      {/* ข้อความ error (ถ้ามี) */}
      {errorMessage && (
        <div className="text-sm text-red-600 text-right mt-2">
          {errorMessage}
        </div>
      )}
    </div>
  );
}
